<template>
  <div>
    <vs-prompt
      title="Create a new meeting"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Create"
      :is-valid="validForm"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Meeting template</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vx-tooltip text="Choose which meeting template you want to use" position="bottom">
                <vs-select label="Meeting template" v-model="meetingId">
                  <vs-select-item :key="meeting.id" :value="meeting.id" :text="meeting.title" v-for="meeting in meetings" />
                </vs-select>
              </vx-tooltip>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      meetingId: "",
      prompt: false
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      meetings: "meetings/allByVenue"
    }),
    validForm() {
      return this.meetingId !== "";
    }
  },
  methods: {
    async show() {
      this.meetingId = "";
      this.prompt = true;

      // Fetch all meetings
      this.$vs.loading();
      await this.$store.dispatch("meetings/getAllByVenue", { venueId: this.activeVenue.venueId });
      this.$vs.loading.close();
    },
    async accept() {
      this.$vs.loading();

      try {
        var result = await this.$store.dispatch("meetingInstances/createMeetingInstance", {
          meetingId: this.meetingId,
          venueId: this.activeVenue.venueId
        });

        this.$router
          .push({
            name: "vp-meeting",
            params: {
              id: result
            }
          })
          .catch(e => {});

        this.$vs.notify({
          color: "green",
          title: `Meeting created`,
          text: "Meeting created successfully"
        });
      } catch (err) {
        this.$vs.notify({
          color: "danger",
          title: `Error creating meeting`,
          text: err,
          time: 4000
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    close() {}
  }
};
</script>

<style lang="scss" scoped>
</style>
